/**
 * Résolution du logo d'une marque d'hôtel pour le simulateur.
 * Utilisé par SimulatorForm (sélection) et SimulatorResults (en-tête).
 */
/* eslint-disable global-require */
const delanoLogo = require("../img/simulator/delano.svg");
const hoxtonLogo = require("../img/simulator/hoxton.svg");
const theSebelLogo = require("../img/simulator/TheSebel.svg");
const mantisLogo = require("../img/simulator/Mantis.svg");
const logo21c = require("../img/simulator/21c-logo.png");
const logo25hours = require("../img/simulator/25hours.png");
const logoAdagioAccess = require("../img/simulator/adagio-access.jpg");
const logoAdagio = require("../img/simulator/Adagio.png");
const logoAdagioPremium = require("../img/simulator/AdagioPremium.png");
const logoArtSeries = require("../img/simulator/ArtSeries.png");
const logoBanyanTree = require("../img/simulator/banyan_tree.png");
const logoEmblems = require("../img/simulator/emblems.jpg");
const logoFaena = require("../img/simulator/faena.jpg");
const logoGleneagles = require("../img/simulator/gleneagles.png");
const logoHyde = require("../img/simulator/hyde.avif");
const logoMondrian = require("../img/simulator/mondrian.png");
const logoOrientExpress = require("../img/simulator/orient-express.webp");
const logoOurHabitas = require("../img/simulator/OUR-HABITAS.png");
const logoRedbury = require("../img/simulator/redbury.jpg");
const logoRixos = require("../img/simulator/rixos.png");
const logoSLS = require("../img/simulator/SLS.webp");
const logoSo = require("../img/simulator/SO.jpeg");
const logoSwissotel = require("../img/simulator/swissotel.png");
const logoTheOriginals = require("../img/simulator/the-originals.jpg");
/* eslint-enable global-require */

const hotelLogoMap = {
  "21C": logo21c,
  "25_Hours": logo25hours,
  Adagio_Access: logoAdagioAccess,
  Adagio_Original: logoAdagio,
  Adagio_Premium: logoAdagioPremium,
  Art_Series: logoArtSeries,
  Banyan_Tree: logoBanyanTree,
  Breakfree: require("../img/simulator/Breakfree.png"),
  Delano: delanoLogo.default || delanoLogo,
  Emblems: logoEmblems,
  Faena: logoFaena,
  Fairmont: require("../img/simulator/Fairmont.png"),
  Gleneagles: logoGleneagles,
  Grand_Mercure: require("../img/simulator/Grand_Mercure.png"),
  greet: require("../img/simulator/greet.png"),
  Handwritten: require("../img/simulator/Handwritten.png"),
  hotelF1: require("../img/simulator/hotelF1.png"),
  Hoxton: hoxtonLogo.default || hoxtonLogo,
  Hyde: logoHyde,
  ibis: require("../img/simulator/ibis.png"),
  ibis_Budget: require("../img/simulator/ibis_Budget.png"),
  ibis_Styles: require("../img/simulator/ibis_Styles.png"),
  "JO&JOE": require("../img/simulator/JO&JOE.png"),
  Mama_Shelter: require("../img/simulator/Mama_Shelter.png"),
  Mantis: mantisLogo.default || mantisLogo,
  Mantra: require("../img/simulator/Mantra.png"),
  Mercure: require("../img/simulator/Mercure.png"),
  MGallery: require("../img/simulator/MGallery.png"),
  Mondrian: logoMondrian,
  Mövenpick: require("../img/simulator/Mövenpick.png"),
  Novotel: require("../img/simulator/Novotel.png"),
  Orient_Express: logoOrientExpress,
  Our_Habitas: logoOurHabitas,
  Peppers: require("../img/simulator/Peppers.png"),
  Pullman: require("../img/simulator/Pullman.png"),
  Raffles: require("../img/simulator/Raffles.png"),
  Redbury_Hotels: logoRedbury,
  Rixos: logoRixos,
  SLS: logoSLS,
  Sofitel: require("../img/simulator/Sofitel.png"),
  So: logoSo,
  Swissotel: logoSwissotel,
  The_Originals: logoTheOriginals,
  The_Sebel: theSebelLogo.default || theSebelLogo,
  Tribe: require("../img/simulator/Tribe.png"),
};

/**
 * Retourne l'URL (ou le module) du logo pour une clé de marque, ou null si absent.
 * @param {string} hotelKey - Clé de la marque (ex. "Novotel", "Mercure")
 * @returns {string|object|null}
 */
export function getHotelLogoSrc(hotelKey) {
  const m = hotelLogoMap[hotelKey];
  if (!m) return null;
  return typeof m === "string" ? m : (m.default ?? m);
}
